import { useEffect } from 'react';

import cx from 'classnames';
import i18next from 'i18next';

import { updateDontShowConfirmationCheckbox } from 'actions/placeorder';
import { APP_DRAWER_TAB_ID_MAPPING } from 'reducers/initialstate/appDrawer';
import {
  appDrawerSelector,
  marketOrderUserPreferenceSelector,
} from 'selectors/otherSelectors';
import {
  dontShowConfirmationCheckboxCheckedSelector,
  slippageCheckSelector,
} from 'selectors/placeOrderSelector';
import { useAppDispatch, useAppSelector } from 'storeHooks';
import MuiCheckBox from 'UIKit/MuiCheckBox';

import DontShowConfirmationForChartPage from './DontShowConfirmationForChart';
import styles from './Modals.module.scss';

const dontShowAgainLabel = i18next.t('trading:dontShowAgain');

const DontShowConfirmation = () => {
  const dispatch = useAppDispatch();
  const slippageCheck = useAppSelector(slippageCheckSelector);
  const checked = useAppSelector(dontShowConfirmationCheckboxCheckedSelector);
  const { activeTab } = useAppSelector(appDrawerSelector);

  const showConfirmation = useAppSelector(marketOrderUserPreferenceSelector);

  useEffect(() => {
    if (showConfirmation === checked) {
      dispatch(updateDontShowConfirmationCheckbox(!showConfirmation));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showConfirmation]);

  if (activeTab === APP_DRAWER_TAB_ID_MAPPING.CHART_ORDERBOOK) {
    return <DontShowConfirmationForChartPage />;
  }

  if (slippageCheck) {
    return null;
  }

  const handleCheck = () => {
    dispatch(updateDontShowConfirmationCheckbox(!checked));
  };

  return (
    (<div
      className={cx(
        'flex--align-items-center',
        styles.checkboxRow,
        styles.check,
        styles.onlyShowForDesktop
      )}
      data-palette="DontShowConfirmation">
      <div className="col-2" data-testid="dontShowAgainCheckbox">
        <MuiCheckBox
          name="donShowConfirmation"
          id="donShowConfirmation"
          checked={checked}
          onChange={handleCheck}
          data-testid="donShowConfirmationCheckbox"
        />
      </div>
      <div
        aria-hidden="true"
        data-testid="dontShowAgainButton"
        onClick={handleCheck}
        className={cx('col-22', styles.dontValue)}
      >
        {dontShowAgainLabel}
      </div>
    </div>)
  );
};

export default DontShowConfirmation;
